import classes from "./Projects.module.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import EzQuant from "../../images/ezquant.svg";
import Couponshelf from "../../images/couponshelf.svg";
import Salarybook from "../../images/salarybook.png";
import Slick from "../../images/slick.svg";
import Vaibhav from "../../images/vaibhav.png";

const projects = [
  {
    image: EzQuant,
    title: "EzQuant",
    link: "https://ezquant.in",
  },
  {
    image: Couponshelf,
    title: "Couponshelf",
    link: "https://couponshelf.in",
  },

  {
    image: Salarybook,
    title: "Salarybook",
    link: "https://salarybook.co.in",
  },
  {
    image: Slick,
    title: "Slick",
    link: "https://slick-one.vercel.app",
  },

  {
    image: Vaibhav,
    title: "Vaibhav",
    link: "https://vaibhav.wtf",
  },
];

const Projects = (props) => {
  const { isDark } = props;
  return (
    <div className={classes.projects}>
      <div className={classes.projects_heading}>Projects</div>
      <div
        className={classes.backgroundCircle}
        style={{
          border: isDark
            ? "2px solid rgba(254, 254, 254, 0.212)"
            : "2px solid rgba(9, 9, 22, 0.212)",
        }}
      >
        <div
          className={classes.innerCircle}
          style={{
            border: isDark
              ? "2px solid rgba(254, 254, 254, 0.212)"
              : "2px solid rgba(9, 9, 22, 0.212)",
            backgroundColor: isDark ? "#090916" : "#fefefe",
          }}
        ></div>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={50}
        centeredSlides={true}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          700: {
            slidesPerView: 2,
            spaceBetween: 100,
          },
        }}
        grabCursor
        className={classes.projects_slider}
      >
        {projects.map((project, index) => (
          <SwiperSlide className={classes.projects_slide}>
            <div
              className={classes.projects_slide_wrapper}
              style={{
                background: isDark
                  ? `linear-gradient(
                    211.13deg,
                    rgba(254, 254, 254, 0.06) 12.68%,
                    rgba(254, 254, 254, 0) 81.17%
                )`
                  : `linear-gradient(211.13deg, rgba(249, 105, 131, 0.04) 12.68%, rgba(203, 92, 230, 0.02) 81.17%)`,
                border: isDark
                  ? "1px solid rgba(254, 254, 254, 0.12)"
                  : "1px solid rgba(203, 92, 230, 0.52)",
              }}
            >
              <div className={classes.projects_slide_wrapper_image}>
                <img src={project.image} alt="HTML" layout="fixed" />
              </div>
              <div className={classes.projects_slide_wrapper_title}>
                {project.title}
                <a
                  href={project.link}
                  target="_blank"
                  className={classes.projects_slide_wrapper_link}
                >
                  Open
                </a>
              </div>
            </div>
            <div
              className={classes.projects_slide_number}
              style={{
                backgroundClip: "text",
              }}
            >
              0{index + 1}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Projects;
